import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-corporate-wrapper',
  templateUrl: './corporate-wrapper.component.html',
  styleUrls: ['./corporate-wrapper.component.css']
})
export class CorporateWrapperComponent implements OnInit {
  isInspectionDot = false;
  subMenu = 'list';


  constructor(
    private router: Router
  ) {
    console.log('state', this.router.getCurrentNavigation().extras.state);
    const state = this.router.getCurrentNavigation().extras.state;
    if (state && state.isMapper && Boolean(state.isMapper)) {
      this.onSelectSubMenu('mapper');
    }
    else if (state && state.isChangeReason && Boolean(state.isChangeReason)) {
      this.onSelectSubMenu("cancel-reason");
    }
    else if (state && state.isFundingSourceConfiguration && Boolean(state.isFundingSourceConfiguration)) {
      this.onSelectSubMenu("configurations");
    }
    else {
      this.onSelectSubMenu("list");
    }
  }

  ngOnInit() {}

  onSelectSubMenu(menu) {
    this.subMenu = menu;
    if (this.subMenu === 'mapper') {
      this.isInspectionDot = false;
    }
  }

}
